import { Route, Routes } from "react-router-dom";

import {
  AssetManagerRoutes,
  AuthenticatedRoutes,
  AuthenticationRoutes,
  DeveloperRoutes,
  DevelopmentManagerRoutes,
  PublicRoutes,
  VerifierRoutes,
} from "./navigators";
import { NotificationProvider } from "./NotificationContext";
import { useAppRouter } from "./useAppRouter";
import { RouterContextProvider } from "./useRouterContext";
import { useShowBrowserConfirmationDialog } from "./utils";
import { ChartVariantProvider } from "./widget";

export const AppRouter = (): JSX.Element => {
  useAppRouter();
  useShowBrowserConfirmationDialog();

  return (
    <RouterContextProvider>
      <NotificationProvider>
        <Routes>
          <Route path="*" element={<AuthenticationRoutes />} />

          <Route path="/a/*" element={<AuthenticatedRoutes />} />

          <Route path="/d/*" element={<DeveloperRoutes />} />

          <Route path="/v/*" element={<VerifierRoutes />} />

          {/* Asset Manager & Development Manager use the Seed brand (Figtree + rounded charts). */}
          <Route
            path="/dm/*"
            element={
              <ChartVariantProvider value="seed">
                <DevelopmentManagerRoutes />
              </ChartVariantProvider>
            }
          />

          <Route path="/p/*" element={<PublicRoutes />} />

          <Route
            path="/am/*"
            element={
              <ChartVariantProvider value="seed">
                <AssetManagerRoutes />
              </ChartVariantProvider>
            }
          />
        </Routes>
      </NotificationProvider>
    </RouterContextProvider>
  );
};
